// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getTipeKaryawan, insertTipeKaryawan, tipeKaryawanSelector, updateTipeKaryawan} from './tipeKaryawanSlice';
import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

const TipeKaryawanPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const tipeKaryawan = useSelector(
        tipeKaryawanSelector
    );

    useEffect(() => {
        dispatch(getTipeKaryawan({
            start: start,
            count: count,
            search: '',
        }));
    }, []);

    useEffect(() => {

        if ((search !== '') && tipeKaryawan.isGetSuccess && !tipeKaryawan.isGetFetching) {
            let calc = tipeKaryawan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = tipeKaryawan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && tipeKaryawan.isGetSuccess && !tipeKaryawan.isGetFetching) {
            let calc = tipeKaryawan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = tipeKaryawan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!tipeKaryawan?.isGetFetching && tipeKaryawan.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = tipeKaryawan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = tipeKaryawan.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getTipeKaryawan({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (tipeKaryawan.isGetSuccess) {
                alertService.success(tipeKaryawan.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getTipeKaryawan({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (tipeKaryawan.isUpdateSuccess) {
                alertService.success(tipeKaryawan.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateTipeKaryawan({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetTipeKaryawan(params) {
    //   return dispatch(getTipeKaryawan(params));
    // }

    function handleInsertTipeKaryawan(param) {
        setInsertFetch(true);
        const params = {
            namaTipeKaryawan: param.inputOneValue,
            tipeKaryawanID: param.dropdownOneValue,
        };
        dispatch(insertTipeKaryawan(params));
    }

    function handleUpdateTipeKaryawan(param) {
        setUpdateFetch(true);

        const params = {
            namaTipeKaryawan: param.inputOneValue,
            idTipeKaryawan: currentData.TipeKaryawanID,
            status: param.status,
        };
        dispatch(updateTipeKaryawan(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getTipeKaryawan(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getTipeKaryawan(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (tipeKaryawan.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? tipeKaryawan.count : newCount,
            search: search,
        }
        dispatch(getTipeKaryawan(params));

        setPage(1);
        setCount((newCount === "-1") ? tipeKaryawan.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>


                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="TipeKaryawan"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master TipeKaryawan"
                                tableData={tipeKaryawan.data}
                                colOneTitle="ID"
                                colOneData="TipeKaryawanID"
                                colTwoTitle="Nama TipeKaryawan"
                                colTwoData="NamaTipeKaryawan"
                                status="Status"

                                fetching={tipeKaryawan.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Tipe Karyawan"
                        inputOneTitle="Nama Tipe Karyawan"
                        inputOnePlaceholder=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertTipeKaryawan}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.TipeKaryawanID}
                        modal={handleModal}
                        modalTitle="Ubah Tipe Karyawan"
                        inputOneTitle="Nama Tipe Karyawan"
                        inputOneValue={currentData.NamaTipeKaryawan}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateTipeKaryawan}
                    />
                }
            </div>

        )
    }

}


export default TipeKaryawanPage;